// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"f7784198","410":"03586d2f","495":"1a9e7393","992":"cfcb4bca"}[chunkId] + ".chunk.css";
};